module.exports = __webpack_public_path__ + "img/page04_text.de8bc8e9.png";